import React from 'react';
import Button from '@saucelabs/sl-component-buttons';

import Styles from './EmptyState.styles';
import Image from './empty-builds.png';
import trackEvent, { DOCUMENTATION_EVENTS } from './../../tracking';

const BuildsEmptyState = () => (
  <div className={Styles['empty-state']}>
    <h3 style={{ backgroundImage: `url(${Image})` }}>Organizing by builds is a snap</h3>
    <p>{"Simply provide the build key with the value of your build's unique identifier."}</p>
    <div>
      <span className={Styles['info-box']}>
        {'"build": "build-1234"'}
      </span>
    </div>
    <Button
      category="primary"
      href="https://wiki.saucelabs.com/display/DOCS/Annotating+Tests+with+the+Sauce+Labs+REST+API"
      onClick={() => {
        trackEvent(DOCUMENTATION_EVENTS.ANNOTATING_TESTS);
      }}
      target="_blank"
    >
      Learn more about annotating tests
    </Button>
  </div>
);

export default BuildsEmptyState;
